/* eslint-disable react/display-name */
import { Fade } from "@mui/material";
import { ThemeProvider } from "@mui/material/styles";
import { LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import { SnackbarProvider } from "notistack";
import { QueryClientProvider } from "react-query";
import { Layout } from "./src/components/Layout";
import SnackbarInAxios from "./src/components/snackbar-in-axios";
import { queryClient } from "./src/utils/react-query-util";
import { theme } from "./src/utils/theme.ts";

// Wraps every page in a component
export const wrapPageElement = ({ element, props }) => {
  return <Layout {...props}>{element}</Layout>;
};

export const onRouteUpdate = ({ location, prevLocation }) => {
  window.analytics &&
    window.analytics.page(location.href, {
      path: location.pathname,
      url: location.href,
      referrer: prevLocation ? prevLocation.href : null,
    });
};

export const wrapRootElement = ({ element }) => {
  return (
    <QueryClientProvider client={queryClient} contextSharing>
      <ThemeProvider theme={theme}>
        <LocalizationProvider dateAdapter={AdapterDateFns}>
          <SnackbarProvider
            maxSnack={1}
            preventDuplicate
            anchorOrigin={{
              vertical: "top",
              horizontal: "center",
            }}
            TransitionComponent={Fade}
          >
            <SnackbarInAxios>{element}</SnackbarInAxios>
          </SnackbarProvider>
        </LocalizationProvider>
      </ThemeProvider>
    </QueryClientProvider>
  );
};
